// extracted by mini-css-extract-plugin
module.exports = {"imageFigure":"Image_imageFigure__1rmk-","imageFigureCaption":"Image_imageFigureCaption__wX9wW","imageFigureLoading":"Image_imageFigureLoading__1PVnZ"};